(function () {
  const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function parseBool(v, fallback = true) {
    if (v == null) return fallback;
    return String(v).toLowerCase() === 'true';
  }

  function initScribbles(root = document) {
    const els = Array.from(root.querySelectorAll('.scribble'));
    if (!els.length || !window.RoughNotation) return;

    const annos = els.map(el => {
      const cssStroke = getComputedStyle(el).getPropertyValue('--stroke')?.trim();
      const cssPad = getComputedStyle(el).getPropertyValue('--pad')?.trim();

      const opts = {
        type: el.dataset.type || 'circle',
        color: el.dataset.color || '#2563eb',
        strokeWidth: Number(cssStroke || el.dataset.stroke || 4),
        padding: Number(cssPad || el.dataset.pad || 6),
        iterations: Number(el.dataset.iters || 2),
        multiline: parseBool(el.dataset.multiline, true),
        animationDuration: prefersReduced ? 0 : Number(el.dataset.duration || 800)
      };
      return RoughNotation.annotate(el, opts);
    });

    const io = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const idx = els.indexOf(entry.target);
        if (idx === -1) return;
        if (entry.isIntersecting) annos[idx].show();
      });
    }, { threshold: 0.6 });

    els.forEach(el => io.observe(el));
  }

  document.addEventListener('DOMContentLoaded', () => initScribbles());
  document.addEventListener('shopify:section:load', e => initScribbles(e.target));
})();